import React from "react";

import { graphql } from "gatsby";

import RichText from "cms/components/RichText";

import { Container, Content, Headline, Pitch } from "./PitchBlock.styles";
import Text from "cms/components/Text";

export interface PitchBlockProps extends Queries.SanityPitchBlock {}

const PitchBlock: React.FC<PitchBlockProps> = ({
  headline,
  _rawPitch,
  fullWidth,
}) => (
  <Container>
    <Content>
      {headline && (
        <Text variant="H2" as="h2" textAlign="center">
          {headline}
        </Text>
      )}
      <Pitch $fullWidth={fullWidth ?? undefined}>
        <RichText text={_rawPitch} />
      </Pitch>
    </Content>
  </Container>
);

export const query = graphql`
  fragment PitchBlock on SanityPitchBlock {
    _key
    _type
    headline
    _rawPitch(resolveReferences: { maxDepth: 5})
    fullWidth
  }
`;

export default PitchBlock;
